"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledContainer = styled_components_1.default.div `
  height: 75%;
  margin: 60px 50px 0;

  @media ${config_1.device.laptop} {
    margin: 60px 200px 0;
  }
`;
